import React, {Fragment} from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import PollEditor from "../PollEditor";
import FragmentEditor from "../FragmentEditor";
import ModalEditor from "../ModalEditor";
import {loadComponent} from "../../../utils/components";
import Icon from "../../form/Icon";
import QuizAnswerField from "./QuizAnswer/QuizAnswerField";
import Select from "../../form/Select";
import EventReservationOptionList from "../lists/EventReservationOptionList";
import {CurrencyFormatter} from "../../../utils/formatters";


class EventReservationOptionForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">

                        <>
                            <div className="col-md-6">
                                <ComponentField
                                    getFieldProps={this.props.getFieldProps}
                                    componentConfig={this.props.componentConfig}
                                    name="answer"
                                    values={this.props.values}
                                    setFieldValue={this.props.setFieldValue}
                                    label="Válasz"
                                />
                            </div>
                            <div className="col-md-4">
                                <ComponentField
                                    getFieldProps={this.props.getFieldProps}
                                    componentConfig={this.props.componentConfig}
                                    name="listprice"
                                    values={this.props.values}
                                    setFieldValue={this.props.setFieldValue}
                                    label="Ár"
                                    formatter={CurrencyFormatter}
                                />
                            </div>
                            <div className="col-md-2">
                                <ComponentField
                                    getFieldProps={this.props.getFieldProps}
                                    componentConfig={this.props.componentConfig}
                                    name={this.props.componentConfig.idfield}
                                    values={this.props.values}
                                    setFieldValue={this.props.setFieldValue}
                                    label="Kód"
                                />
                            </div>
                        </>

                </div>
                {/*<div className="row form-row">*/}
                {/*    <div className="col-sm-12">*/}
                {/*        <ComponentField*/}
                {/*            getFieldProps={this.props.getFieldProps}*/}
                {/*            componentConfig={this.props.componentConfig}*/}
                {/*            name="subtitle"*/}
                {/*            values={this.props.values}*/}
                {/*            setFieldValue={this.props.setFieldValue}*/}
                {/*            label="Alcím"*/}
                {/*        />*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*<div className="row form-row">*/}
                {/*    <div className="col-sm-12">*/}
                {/*        <ComponentField*/}
                {/*            getFieldProps={this.props.getFieldProps}*/}
                {/*            componentConfig={this.props.componentConfig}*/}
                {/*            name="description"*/}
                {/*            values={this.props.values}*/}
                {/*            setFieldValue={this.props.setFieldValue}*/}
                {/*            label="Leírás"*/}
                {/*        />*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*{!!this.props.values[this.props.componentConfig.idfield] && <div className="row">*/}
                {/*    <div className="col-md-12">*/}
                {/*        <div className="form-group">*/}
                {/*            <label className="control-label">Kérdések</label>*/}
                {/*            <PollEditor*/}
                {/*                editorContext="QuizPoll"*/}
                {/*                presets={{quiz: this.props.values}}*/}
                {/*                listFilter={{*/}
                {/*                    field: "quiz",*/}
                {/*                    value: this.props.values[this.props.componentConfig.idfield]*/}
                {/*                }}*/}
                {/*                list={FragmentEditor}*/}
                {/*                editor={ModalEditor}*/}
                {/*            />*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>}*/}
                {/*{this.props.values[this.props.componentConfig.idfield] && <QuizAnswerField*/}
                {/*    quiz_id={this.props.values[this.props.componentConfig.idfield]}*/}
                {/*    label="Válaszok"*/}
                {/*/>}*/}
            </form>
        );
    }
}

export default createForm(EventReservationOptionForm);
